import React from "react";
import {Organization, OrganizationRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Box, Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {types} from "../../../../components/form/types";
import {RecordAttachments} from "../../../../components/record_attachments";

export const OrganizationEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(OrganizationRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getOrganization(id),
        updater: (bean) => ctrl.saveOrganization(bean),
        remover: (id) => ctrl.deleteOrDismissOrganization(id),
        factory: () => ({} as Organization),
    } as UseFormProps<Organization>);

    return (
        <>
        <FormContent form={form} title={"Formulario de organización"}>
            <FormInput field={"name"} label={"Nombre"}/>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"email"} label={"Email"} type="email"/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"mainActivity"} label={"Actividad principal"}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"website"} label={"Web"}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"linkedin"} label={"LinkedIn"}/>
                </Grid>
            </Grid>

            <FormAutocomplete
                field={"customer"}
                label={"Cliente de facturación (cierra la atribución lead → €)"}
                type={types.customers}
            />

            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <FormSelect field={"status"} label={"Situación"} type={types.organizationStatuses}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"leaveDate"} label={"Fecha de baja"} type="date"/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"leaveReason"} label={"Motivo de la baja"}/>
                </Grid>
            </Grid>

            <FormInput field={"observation"} label={"Observaciones"} rows={4}/>
        </FormContent>
        <Box sx={{mt: 3}}>
            <RecordAttachments recordType="ORGANIZATION" recordId={form.getId()}/>
        </Box>
        </>
    );
};
